import React from "react";
import { CardShopComponent } from "./CardShopComponent";
import { useProductUnits } from "../Repository/useProductUnits";
import { OrderComponent } from "./OrderComponent";
import SearchComponent from "./SearchComponent";
import ProductDetailComponent from "./ProductDetailComponent";

export function ProductUnitComponentWrapper(props) {
    const { units, loading, error } = useProductUnits();

    if (loading) {
        return <div style={{ textAlign: "center", padding: "2rem" }}>در حال بارگذاری واحدها...</div>;
    }

    if (error) {
        return <div style={{ color: "red", textAlign: "center" }}>خطا در بارگذاری واحدها: {error}</div>;
    }

    switch (props.route) {
        case "order":
            return <OrderComponent {...props} units_prop={units} />;

        case "cardShop":
            return <CardShopComponent {...props} units_prop={units} />;

        case "search":
            return <SearchComponent {...props} units_prop={units} />;

        case "product_detail":
            return  <ProductDetailComponent id={props.product_id}/>

        default:
            return <div>مسیر نامعتبر است.</div>;
    }
}
